// ##### Komarov 2025-05-26
import React from 'react';
// ##### 25-05-21 Komarov
import ClientDetailsForm from './ClientDetailsForm';

// ##### Komarov 2025-07-14
const ClientDetails = ({ formClassName }) => {
  // ##### Komarov 2025-05-26
  return <ClientDetailsForm className={formClassName} />;
};

export default ClientDetails;
